import {
  ADVERT_FORMAT_TYPES,
  FLIGHTS_INLINE_TYPES,
} from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeFlightsInlineFields,
  CreativeFlightsInline,
  CreativeFlightsInlineBrand,
  CreativeFlightsInlineItinerary,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getFlightsInlineCreative = (
  fields: ConductorCreativeFlightsInlineFields,
): CreativeFlightsInline => {
  // We need to build up a new object because flow cannot infer the type after a spread.
  // See https://github.com/facebook/flow/issues/6108
  const {
    appIndex,
    callToActionText,
    carriersCriteria,
    checkoutType,
    deeplink,
    deeplinkParams,
    dimensions,
    excludedCarriers,
    includedCarriers,
    itineraryId,
    layoutType,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    requestedDepth,
    selection,
    splitTestId,
    strevdaId,
    title,
    trackingModifications,
    transferType,
    useFlightsSkippyChannel,
  } = fields;

  const creativeFields = {
    appIndex,
    callToActionText,
    deeplink,
    deeplinkParams,
    itineraryId,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    partnerName: null,
    redirectUrl,
    removeDeeplinkIds: null,
    requestedDepth,
    selection,
    strevdaId,
    title,
    format: ADVERT_FORMAT_TYPES.INLINE,
    carriersCriteria: carriersCriteria || 'all',
    includedCarriers: includedCarriers ? includedCarriers.split(',').map(Number) : [],
    excludedCarriers: excludedCarriers ? excludedCarriers.split(',').map(Number) : [],
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };

  if (layoutType === FLIGHTS_INLINE_TYPES.BRAND) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
      ...creativeFields,
      checkoutType,
      dimensions,
      trackingModifications,
      useFlightsSkippyChannel,
      layoutType: FLIGHTS_INLINE_TYPES.BRAND,
    } as CreativeFlightsInlineBrand;
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    ...creativeFields,
    checkoutType,
    dimensions,
    trackingModifications,
    useFlightsSkippyChannel,
    transferType,
    layoutType: FLIGHTS_INLINE_TYPES.ITINERARY,
  } as CreativeFlightsInlineItinerary;
};
